import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";
import { QUICK_OPTIONS } from "./staticFaq";

const QuickOptions = ({ actionProvider }) => {
  return (
    <div className="static-chatbot-options">
      {QUICK_OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          className="static-chatbot-option-btn"
          onClick={() => actionProvider.handleFaqSelection(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

const config = {
  initialMessages: [
    createChatBotMessage(
      "Hello! Thank you for reaching out to Dubai Chambers Arbitration Center. How can I assist you?",
      {
        withAvatar: true,
        widget: "quickOptions",
      },
    ),
  ],
  botName: "Dubai Chambers",
  customStyles: {
    botMessageBox: {
      backgroundColor: "#0f9d58",
    },
    chatButton: {
      backgroundColor: "#0f9d58",
    },
  },
  customComponents: {
    botAvatar: () => <div className="static-chatbot-bot-avatar">DC</div>,
  },
  widgets: [
    {
      widgetName: "quickOptions",
      widgetFunc: (props) => <QuickOptions {...props} />,
    },
  ],
};

export default config;
